import CommonEmailChange from '../../../common/pages/secure/EmailChange'
import Config from '../../../Config'

class EmailChange extends CommonEmailChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.apiUrl = Config.companyUserApiUrl.emailChange
  }
}

export default EmailChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EmailChange.js